import * as z from "zod/v4";

const ShopifyCategoryItemSchema_ = z.object({
  id: z.string(),
  shopifyId: z.string(),
  name: z.string(),
  hasChildren: z.boolean(),
});

export const ShopifyCategoryItemSchema: z.ZodType<ShopifyCategoryItem> =
  ShopifyCategoryItemSchema_;
export interface ShopifyCategoryItem
  extends z.infer<typeof ShopifyCategoryItemSchema_> {}

export const getShopifyCategories = {
  name: "getShopifyCategories" as const,
  input: z.object({
    parentId: z.string().optional(),
  }),
  output: z.object({
    items: z.array(ShopifyCategoryItemSchema),
  }),
};
